export default "__VITE_ASSET__Bec6eTfD__"